export default "__VITE_ASSET__902f953b__"